import React from 'react'
import './HorizontalBar.css'

interface HorizontalBarProps {
    value: number
    maxValue: number
    label?: string
    barHeight?: number
    maxWidth?: number
    labelWidth?: number
    formatValue?: (value: number) => string
}

const defaultFormat = (value: number) =>
    value.toLocaleString('en-US')

const HorizontalBar = ({
    value,
    maxValue,
    label,
    barHeight = 20,
    maxWidth = 200,
    labelWidth = 130,
    formatValue = defaultFormat,
}: HorizontalBarProps) => {
    const barWidth = maxValue > 0 ? (value / maxValue) * maxWidth : 0
    const baseHeight = barHeight * 2

    return (
        <div style={{ display: 'flex', alignItems: 'center', minHeight: baseHeight }}>
            {label && (
                <div
                    className='hotizontal-bar__label'
                    style={{
                        width: labelWidth,
                        minWidth: labelWidth,
                    }}
                >
                    {label}
                </div>
            )}
            <div
                style={{
                    width: 2,
                    alignSelf: 'stretch',
                    backgroundColor: '#D0D5DD',
                    flexShrink: 0,
                }}
            />
            <div
                style={{
                    width: barWidth,
                    height: barHeight,
                    backgroundColor: '#6941C6',
                    flexShrink: 0,
                    transition: 'width 0.4s ease',
                }}
            />
            <span
                className='horizontal-bar__value'
            >
                {formatValue(value)}
            </span>
        </div>
    )
}

export default HorizontalBar
